import JrttDataSourceController from './JrttDataSourceController';
import { transformTreeKey } from '@/tools/form';
import { getBrandListApi, getBrandCategoryListApi } from '@/api/tool/brand';

/**
 * 管理头条智擎版渠道的数据
 */
export default class JrttV3DataSourceController extends JrttDataSourceController {
  normalizeDeliveryContentParams(list = []) {
    return list.map(item => ({
      ...item,
      ...((item.jrtt_params && !item.jrtt_v3_params) && {
        jrtt_v3_params: item.jrtt_params,
      }),
    }));
  }

  async getDeliveryContentById(advertiser_id, filtering = {}) {
    try {
      const result = await super.getDeliveryContentById(advertiser_id, filtering);
      return Promise.resolve(this.normalizeDeliveryContentParams(result));
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**
   * 获取品牌形象列表
   * @returns {Promise<Object[]>}
   */
  async getBrandList() {
    try {
      const params = {
        channel_interface: this.getChannelInterfaceEnum(),
        advertiser_id: this.getRequestAdvertiser(),
      };
      const ret = await getBrandListApi(params);
      const result = (ret?.list || [])
        .filter(({ jrtt_v3_params = {}}) => jrtt_v3_params.cdp_brand_id && jrtt_v3_params.cdp_brand_name)
        .map(({ jrtt_v3_params = {}}) => ({
          label: jrtt_v3_params.cdp_brand_name,
          value: `${jrtt_v3_params.cdp_brand_id}#${jrtt_v3_params.cdp_brand_name}`,
          jrtt_v3_params,
        }));
      return Promise.resolve(result);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**
   * 获取品牌形象分类列表
   * @param {Object} filtering 渠道过滤条件
   * @param {string|number} filtering.outer_brand_id 品牌数据来源方的品牌 id
   * @returns {Promise<Object[]>}
   */
  async getBrandCategoryList(filtering = {}) {
    try {
      const { outer_brand_id } = filtering;
      if (!outer_brand_id) {
        return Promise.resolve([]);
      }
      const params = {
        channel_interface: this.getChannelInterfaceEnum(),
        advertiser_id: this.getRequestAdvertiser(),
        jrtt_v3_params: {
          filtering: {
            outer_brand_id,
          },
        },
      };
      const ret = await getBrandCategoryListApi(params);
      const result = transformTreeKey({ options: ret?.list || [], value_key: 'id' });
      return Promise.resolve(result);
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
